import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
type ShimmerTextProps = {
  text?: string;
  children?: React.ReactNode;
  className?: string;
  icon?: Icon;
};
const ShimmerText = t0 => {
  const $ = _c(13);
  const {
    text,
    children,
    icon: PrefixIcon,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("inline-flex items-center gap-1 w-fit", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      maskImage: "linear-gradient(to right, black 25%, transparent 50%, black 75%)",
      WebkitMaskImage: "linear-gradient(to right, black 25%, transparent 50%, black 75%)",
      maskSize: "300% 100%",
      WebkitMaskSize: "300% 100%",
      animation: "shimmer-mask 1.5s infinite ease-in-out"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== PrefixIcon) {
    t3 = PrefixIcon && <PrefixIcon />;
    $[3] = PrefixIcon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== text) {
    t4 = children ?? <span className="text-label-2">{text}</span>;
    $[5] = children;
    $[6] = text;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <style>{"\n            @keyframes shimmer-mask {\n              0% { mask-position: 100% 0; -webkit-mask-position: 100% 0; }\n              100% { mask-position: 0 0; -webkit-mask-position: 0 0; }\n            }\n          "}</style>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t6 = <div className={t1} style={t2}>{t3}{t4}{t5}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default ShimmerText;